import React from "react";
import "../Card/card.css";

function Card({ icon, title, description, buttonLabel, buttonHref, onClick }) {
  return (
    <div className="card">
      <div className="icon">{icon}</div>
      <h2>{title}</h2>
      <p>{description}</p>

      {onClick ? (
        <button className="card-button" onClick={onClick}>
          {buttonLabel}
        </button>
      ) : (
        <a href={buttonHref} className="card-button">
          {buttonLabel}
        </a>
      )}
    </div>
  );
}

export default Card;
